import React, { ReactElement } from 'react';

export const DefaultIcon = ({ customStyle }: { customStyle?: React.CSSProperties }): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none" style={customStyle}>
      <path
        d="M23.0507 11.5024L20.494 8.57884L20.8496 4.71239L17.0684 3.85318L15.0877 0.5L11.5253 2.03017L7.96299 0.5L5.98231 3.84191L2.20114 4.68986L2.55672 8.56597L0 11.4992L2.55672 14.4228L2.20114 18.2989L5.98231 19.1581L7.96299 22.5L11.5253 20.9602L15.0877 22.4903L17.0684 19.1484L20.8496 18.2892L20.494 14.4228L23.0507 11.4992V11.5024ZM9.52536 16.4469L5.54466 12.4549L7.09573 10.9039L9.52697 13.3447L15.6557 7.19509L17.2068 8.74618L9.52697 16.4469H9.52536Z"
        fill="#95C7EB"
      />
    </svg>
  );
};

export const ActiveIcon = ({ customStyle }: { customStyle?: React.CSSProperties }): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none" style={customStyle}>
      <path
        d="M23.152 11.0024L20.5953 8.07884L20.9509 4.21239L17.1697 3.35318L15.189 0L11.6267 1.53017L8.06431 0L6.08363 3.34191L2.30245 4.18986L2.65804 8.06597L0.101318 10.9992L2.65804 13.9228L2.30245 17.7989L6.08363 18.6581L8.06431 22L11.6267 20.4602L15.189 21.9903L17.1697 18.6484L20.9509 17.7892L20.5953 13.9228L23.152 10.9992V11.0024ZM9.62667 15.9469L5.64598 11.9549L7.19705 10.4039L9.62828 12.8447L15.757 6.69509L17.3081 8.24618L9.62828 15.9469H9.62667Z"
        fill="white"
      />
    </svg>
  );
};
export const WhiteIcon = ({
  customStyle,
  fillColor,
}: {
  customStyle?: React.CSSProperties;
  fillColor?: string;
}): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none" style={customStyle}>
      <path
        d="M11.4189 2.54395L11.5293 2.72754L11.7383 2.77441L13.9326 3.26367L13.7275 5.46191L13.707 5.67871L13.8516 5.84082L15.3291 7.5L13.8516 9.16016L13.707 9.32324L13.7275 9.53906L13.9326 11.7363L11.7383 12.2266L11.5303 12.2734L11.4199 12.4561L10.2676 14.3643L8.19434 13.4893L7.99902 13.4072L7.80469 13.4902L5.73047 14.3701L4.58008 12.4629L4.46973 12.2803L4.26172 12.2334L2.06543 11.7432L2.27246 9.53906L2.29297 9.32227L2.14844 9.16016L0.667969 7.49805L2.14844 5.83105L2.29297 5.66895L2.27246 5.45312L2.06641 3.24902L4.25977 2.7666L4.46973 2.7207L4.58008 2.53711L5.73145 0.628906L7.80566 1.50391L8 1.58594L8.19434 1.50391L10.2666 0.628906L11.4189 2.54395Z"
        stroke={fillColor || '#E2C92D'}
      />
      <path
        d="M11.1748 6.05762L6.68945 10.5977L4.70312 8.58691L5.04688 8.23926L6.33398 9.54395L6.69043 9.9043L7.0459 9.54395L10.8311 5.70996L11.1748 6.05762Z"
        stroke={fillColor || '#E2C92D'}
      />
    </svg>
  );
};

export const VerifiedIcon = ({
  customStyle,
  fillColor = '#2B8FD7',
}: {
  customStyle?: React.CSSProperties;
  fillColor?: string;
}): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none" style={customStyle}>
      <path
        d="M23.1015 11.5024L20.5448 8.57884L20.9004 4.71239L17.1192 3.85318L15.1385 0.5L11.5761 2.03017L8.01377 0.5L6.03309 3.84191L2.25192 4.68986L2.6075 8.56597L0.0507812 11.4992L2.6075 14.4228L2.25192 18.2989L6.03309 19.1581L8.01377 22.5L11.5761 20.9602L15.1385 22.4903L17.1192 19.1484L20.9004 18.2892L20.5448 14.4228L23.1015 11.4992V11.5024ZM9.57614 16.4469L5.59545 12.4549L7.14651 10.9039L9.57775 13.3447L15.7065 7.19509L17.2576 8.74618L9.57775 16.4469H9.57614Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const DefaultIconV2 = ({
  customStyle,
  fillColor = '#212121',
}: {
  customStyle?: React.CSSProperties;
  fillColor?: string;
}): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none" style={customStyle}>
      <path
        d="M16 7.50165L14.2253 5.5083L14.4722 2.87208L11.8476 2.28626L10.4727 0L8 1.0433L5.52729 0L4.15246 2.27858L1.52786 2.85673L1.77468 5.49952L0 7.49945L1.77468 9.4928L1.52786 12.1356L4.15246 12.7214L5.52729 15L8 13.9501L10.4727 14.9934L11.8476 12.7148L14.4722 12.129L14.2253 9.4928L16 7.49945V7.50165ZM6.61176 10.8729L3.84868 8.1511L4.92531 7.09354L6.61288 8.75777L10.867 4.56484L11.9436 5.62239L6.61288 10.8729H6.61176Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const UnsuccessfulIcon = ({
  customStyle,
  fillColor = '#DD0B24',
}: {
  customStyle?: React.CSSProperties;
  fillColor?: string;
}): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none" style={customStyle}>
      <path
        d="M0.5 13L7.98639 0L15.4728 13H0.5ZM7.98639 10.9474C8.17922 10.9474 8.34086 10.8818 8.4713 10.7507C8.60175 10.6195 8.66697 10.457 8.66697 10.2632C8.66697 10.0693 8.60175 9.9068 8.4713 9.77566C8.34086 9.64452 8.17922 9.57895 7.98639 9.57895C7.79356 9.57895 7.63192 9.64452 7.50147 9.77566C7.37103 9.9068 7.30581 10.0693 7.30581 10.2632C7.30581 10.457 7.37103 10.6195 7.50147 10.7507C7.63192 10.8818 7.79356 10.9474 7.98639 10.9474ZM7.30581 8.89474H8.66697V5.47368H7.30581V8.89474Z"
        fill={fillColor}
      />
    </svg>
  );
};
